import { cn } from "./classNames-BzrkDnOD.js";
import { useTheme } from "./context-U293r3v-.js";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import DOMPurify from "dompurify";
//#region src/components/BrandLogo/BrandLogo.tsx
const isInlineSvg = (source) => source.trimStart().startsWith("<");
const resolveLogoSource = (logo, variant, mode) => {
	if (!logo) return void 0;
	const forMode = (light, dark) => mode === "dark" ? dark ?? light : light ?? dark;
	const mark = forMode(logo.mark, logo.markDark);
	const wordmark = forMode(logo.wordmark, logo.wordmarkDark);
	return variant === "mark" ? mark ?? wordmark : wordmark ?? mark;
};
const wrapperClass = "tw:inline-flex tw:h-6 tw:items-center tw:[&>svg]:h-full tw:[&>svg]:w-auto";
/**
* The active brand's logo from the nearest `<ThemeProvider>`, or `null` if it ships none.
* Inline SVG inherits `currentColor`; URLs use `<img>`.
*/
const BrandLogo = ({ variant = "wordmark", className, label }) => {
	const { currentTheme, resolvedScheme } = useTheme();
	const source = resolveLogoSource(currentTheme.logo, variant, resolvedScheme);
	const safeSvg = useMemo(() => source && isInlineSvg(source) ? DOMPurify.sanitize(source, { USE_PROFILES: {
		svg: true,
		svgFilters: true
	} }) : null, [source]);
	if (!source) return null;
	if (safeSvg !== null) return /* @__PURE__ */ jsx("span", {
		role: "img",
		"aria-label": label ?? currentTheme.name,
		className: cn(wrapperClass, className),
		dangerouslySetInnerHTML: { __html: safeSvg }
	});
	return /* @__PURE__ */ jsx("span", {
		className: cn(wrapperClass, className),
		children: /* @__PURE__ */ jsx("img", {
			src: source,
			alt: label ?? currentTheme.name,
			className: "tw:h-full tw:w-auto"
		})
	});
};
//#endregion
export { BrandLogo };

//# sourceMappingURL=BrandLogo-CKpVSZb6.js.map